import { render, staticRenderFns } from "./CumulativeFrequency.vue?vue&type=template&id=584c9375&scoped=true"
import script from "./CumulativeFrequency.vue?vue&type=script&lang=js"
export * from "./CumulativeFrequency.vue?vue&type=script&lang=js"
import style0 from "./CumulativeFrequency.vue?vue&type=style&index=0&id=584c9375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c9375",
  null
  
)

export default component.exports